import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon } from '@heroicons/react/24/outline';

const flowSteps = [
  {
    title: 'Klient opisuje problem',
    description: 'Zdjęcia, objawy i preferowany kontakt w jednym zgłoszeniu.',
  },
  {
    title: 'Serwis dostaje uporządkowaną sprawę',
    description: 'Bez rozmów po omacku i gubienia kontekstu.',
  },
  {
    title: 'Proces rozwijamy z serwisami',
    description: 'Sugestie pomagają ustalić, co uprościć, dodać albo zatrzymać.',
  },
];

const HeroSection: React.FC = () => {
  const primaryLink =
    'inline-flex min-h-[46px] items-center justify-center gap-2 rounded-lg bg-ratuj-400 px-5 py-3 text-sm font-semibold text-white shadow-button transition-colors hover:bg-ratuj-300 focus-outline sm:text-base';
  const secondaryLink =
    'inline-flex min-h-[46px] items-center justify-center gap-2 rounded-lg border border-primary-dark-300/55 bg-primary-dark-100/20 px-5 py-3 text-sm font-semibold text-primary-light-200 transition-colors hover:border-primary-dark-300/80 hover:bg-primary-dark-200/55 hover:text-primary-light-100 focus-outline sm:text-base';
  const tertiaryLink =
    'inline-flex min-h-[44px] w-fit items-center justify-center rounded-lg px-2 text-sm font-semibold text-primary-light-300 transition-colors hover:text-ratuj-200 focus-outline';

  return (
    <section className="relative overflow-hidden bg-primary-dark-100">
      <div className="absolute inset-x-0 top-0 h-px bg-ratuj-300/20" />
      <div className="rs-page-gutter mx-auto grid max-w-7xl gap-9 py-11 sm:py-16 lg:grid-cols-[1.12fr_0.88fr] lg:items-center lg:gap-16 lg:py-20">
        <div className="flex max-w-3xl flex-col justify-center">
          <div className="mb-5 inline-flex w-fit items-center rounded-full border border-ratuj-300/20 bg-ratuj-300/10 px-3 py-1.5 text-xs font-semibold text-ratuj-200 sm:text-sm">
            Wczesny etap - dołącz i miej wpływ
          </div>

          <h1 className="text-4xl font-semibold leading-tight text-primary-light-100 sm:text-5xl lg:text-6xl">
            Zbudujmy lokalną sieć napraw, która naprawdę działa.
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-7 text-primary-light-300 sm:text-lg sm:leading-8">
            Tworzymy miejsce, w którym klient szybciej znajduje lokalny serwis, a serwis dostaje
            prostszą kolejkę zgłoszeń, komunikację i wpływ na rozwój platformy.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link to="/register/service" className={`${primaryLink} w-full sm:w-auto`}>
              Dołącz jako serwis
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
            </Link>
            <Link to="/map" className={`${secondaryLink} w-full sm:w-auto`}>
              Zobacz mapę serwisów
              <MapPinIcon className="h-4 w-4" aria-hidden="true" />
            </Link>
            <Link to="/login" className={`${tertiaryLink} self-center sm:self-auto`}>
              Mam już konto
            </Link>
          </div>
        </div>

        <div className="lg:pl-2">
          <div className="mx-auto max-w-xl lg:max-w-none">
            <div className="rounded-lg border border-primary-dark-300/40 bg-primary-dark-200/48 p-5 sm:p-6 lg:p-7">
              <h2 className="text-sm font-semibold text-ratuj-300">Jak to ma działać</h2>
              <ol className="mt-5 space-y-5">
                {flowSteps.map((step, index) => (
                  <li key={step.title} className="flex gap-4">
                    <span className="mt-0.5 flex h-7 w-7 flex-none items-center justify-center rounded-md bg-primary-dark-100/70 text-xs font-semibold text-ratuj-200">
                      {index + 1}
                    </span>
                    <div
                      className={`min-w-0 ${
                        index < flowSteps.length - 1
                          ? 'border-b border-primary-dark-300/38 pb-5'
                          : ''
                      }`}
                    >
                      <h3 className="text-base font-semibold leading-tight text-primary-light-100">
                        {step.title}
                      </h3>
                      <p className="mt-1.5 text-sm leading-6 text-primary-light-400">
                        {step.description}
                      </p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
